import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import axios from '../../Helpers/Axiosbase';
import * as actions from '../../Store/Actions'
import useReactRouter from 'use-react-router';
import { Button, Typography, TextField, Snackbar, Switch, Checkbox, FormControlLabel, FormControl } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import { makeStyles, ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SaveIcon from '@material-ui/icons/Save';

import AddIcon from '@material-ui/icons/Add';

//Checkbox
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

//Card
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

//Table

import MaterialTable from 'material-table';

//Merge
var merge = require('lodash.merge');

const theme = createMuiTheme({});

const useStyles = makeStyles(theme => ({

    //Stepper
    root: {
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    stepperdiv: {
        marginRight: '15px',
        float: 'right',
    },

    //card
    cardroot: {
        minHeight: 465,
        height: '100%',
    },
}));

//Alert

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


export default function WizardEntityCreateForm(props) {

    const classes = useStyles();
    const { location, history } = useReactRouter();
    const reduxAuth = useSelector((state) => state.auth)
    const appcomponent = useSelector((state) => state.appcomponent)
    const dispatch = useDispatch();

    const [errorMessage, setErrorMessage] = React.useState({
        open: false,
        errmsg: null,
        api:''
      });

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    //RowData
    const [AddRowData, setAddRowData] = React.useState(null)

    //Wizard Form
    const [OpenWizardForm, setOpenWizardForm] = React.useState(false)

    //Component List
    const [ComponentList, setComponentList] = React.useState(["rock-entity-create", "rock-path-attribute-manage", "rock-context-manage", "rock-relationship-manage", "rock-business-function-finish"])

    //User Component
    const [UserComponent, setUserComponent] = React.useState({
        ComponentName: null,
        ComponentPath: null
    })

    //Step Property Form
    const [OpenProperty, setOpenProperty] = React.useState({
        open: false,
        component: null
    })

    //Attribute List For create Step
    const [AttributeList, setAttributelist] = React.useState({
        AttributeList: []
    })

    //userAttributes For Create step
    const [userAttributes, setuserAttributes] = React.useState([])

    //handleAttributes For Create Step
    const handleAttributes = (event, value) => {
        setuserAttributes(value)
    }

    //no of columns For Create Step
    const [NoofColumns, setNoofColumns] = React.useState({
        NoofColumns: 3
    })
    //handle columns For create Step
    const handleColumns = (event) => {
        let col = 3
        col = parseInt(event.target.value, 10)
        if (isNaN(col)) {
            col = 3
        }

        setNoofColumns({
            NoofColumns: col
        })
    }

    //Handle properties for Path Manage
    const [PathManageProperty, setPathManageProperty] = React.useState({
        leafNodeOnly: true,
        pathAttribute: '',
        multiSelect: true
    })

    //handlepathattribute for Path Manage
    const handlepathattribute = (event, value) => {
        setPathManageProperty({
            ...PathManageProperty,
            pathAttribute: value
        })
    }

    //Swich for Path Manage property
    const handleleafnodeswitch = (event, value) => {
        if (event.currentTarget.id === "Leaf Node Only") {
            setPathManageProperty({
                ...PathManageProperty,
                leafNodeOnly: value
            })
        }

        if (event.currentTarget.id === "Multi-Select") {
            setPathManageProperty({
                ...PathManageProperty,
                multiSelect: value
            })
        }


    }

    //Manage property for Relationship manage step
    const [RelManageProperty, setRelManageProperty] = React.useState({
        "do-sync-validation": true,
        "no-of-columns": 2,
        "functional-mode": "dataFunction",
        "mode": "edit",
        "config-context": {
            "relationshipTitle": "",
            "relationshipTypeName": ""
        }
    })

    //handlerelationmanageswitch property for Relationship manage step
    const handlerelationmanageswitch = (event, value) => {
        if (event.currentTarget.id === "do-sync-validation") {
            setRelManageProperty({
                ...RelManageProperty,
                "do-sync-validation": value
            })
        }
    }

    //handlerelpropertytextbox Textbox property for Relationship manage step
    const handlerelpropertytextbox = (event) => {
        if (event.currentTarget.name === "relationshipTitle" || event.currentTarget.name === "relationshipTypeName") {
            let varconfigcontext = RelManageProperty["config-context"]

            let newconfigcontext = {
                [event.currentTarget.name]: event.currentTarget.value
            }
            let mergeconfigcontext = merge(varconfigcontext, newconfigcontext)
            setRelManageProperty({
                ...RelManageProperty,
                "config-context": mergeconfigcontext
            })
        }
        else {
            setRelManageProperty({
                ...RelManageProperty,
                [event.currentTarget.name]: event.currentTarget.value
            })
        }

    }

    //Material table
    const [Steps, setSteps] = React.useState({
        Steps: []
    })

    const [StepsCol, setStepsCol] = React.useState({
        columns: [
            { title: 'Step Name', field: 'name' },
            { title: 'Stepper Title', field: 'stepperTitle' },
            { title: 'Component Path', field: 'component.path' },
            { title: 'Component Name', field: 'component.name', lookup: { "rock-entity-create": "rock-entity-create", "rock-path-attribute-manage": "rock-path-attribute-manage", "rock-context-manage": "rock-context-manage", "rock-relationship-manage": "rock-relationship-manage", "rock-business-function-finish": "rock-business-function-finish" } },
            { title: 'Display Sequence', field: 'displaySequence', type: 'numeric' },
            {
                title: 'Visible',
                field: 'visible',
                // initialEditValue:true,
                editComponent: props => (
                    <Switch checked={props.value !== undefined ? props.value : false} onChange={e => props.onChange(!props.value)} />
                ),
                render: rowData => {
                    if (rowData.visible === undefined) {
                        return <Switch checked={false} onChange={(event) => {
                            rowData.visible = true
                            handlewizarddata(rowData)
                        }} />
                    }
                    if (rowData.visible === true) {

                        return <Switch checked={rowData.visible} onChange={(event) => {
                            rowData.visible = false
                            handlewizarddata(rowData)
                        }} />
                    }
                    if (rowData.visible === false) {
                        return <Switch checked={rowData.visible} onChange={(event) => {
                            rowData.visible = true
                            handlewizarddata(rowData)
                        }} />
                    }
                }
            },
            {
                title: 'Add Properties', render: rowData => {
                    if (rowData) {
                       
                            return <Button
                            disabled={!rowData.visible}
                            variant="contained"
                            color="primary"
                            onClick={() => handleaddproperties(rowData)}
                            startIcon={<AddIcon />}
                            style={{ fontSize: '0.600rem', fontWeight: 600 }}>
                            Property
                             </Button>
                        
                       
                    }

                }
            }
        ]
    });

    //success alert

    const [openalert, setOpenAlert] = React.useState({
        open: false,
        msg: 'Configuration Saved',
    });

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert({
            open: false,
        });
    };

    //Wizard Entity Create static JSON

    const [jsonObj] = React.useState({
        _id: '',
        componentContextCode: '',
        domain: '',
        entityType: '',
        context1: '',
        context2: '',
        context3: '',
        relationship: '',
        role: '',
        app: '',
        isDuplicate: '',
        environmentId: '',
        isDuplicate: false,
        isPublished: true,
        jsonDocument: {
            id: "",
            name: "",
            type: "",
            // properties:"",
            data: {
                contexts: [{
                    context: {
                        component: "_DEFAULT",
                        role: "_DEFAULT",
                        tenant: "_DEFAULT",
                        domain: "_DEFAULT",
                        app: "_DEFAULT",
                        entityType: "_DEFAULT",
                        country: "_DEFAULT",
                        channel: "_DEFAULT",
                        relationship: "_DEFAULT",
                        user: "_DEFAULT"
                    },
                    jsonData: {}
                }]
            }
        }
    })

    const handlebackbutton = (event) => {
        reduxAuth.fullscreentoggle=false
        history.push('./Config')
    };

    //update config API
    const updateConfigAPI = (event) => {

        //update Config

        let url = "configurationUpdate"
        let postdata = null;
        if (event === "add") {
            postdata = {
                _id: props.data._id,
                jsonDocument: jsonObj.jsonDocument,
                isPublished: false,
                componentContextCode: props.data.componentContextCode,
                domain: props.data.domain,
                entityType: props.data.entityType,
                context1: props.data.context1,
                context2: props.data.context2,
                context3: props.data.context3,
                relationship: props.data.relationship,
                role: props.data.role,
                app: props.data.app,
                isDuplicate: props.data.isDuplicate,
                environmentId: props.data.environmentId,
                token: reduxAuth.token,
                userId: reduxAuth.userId
            };
        }
        else {
            location.state.isPublished = false;
            postdata = {
                ...location.state,
                token: reduxAuth.token,
                userId: reduxAuth.userId
            }
        }


        axios.post(url, postdata)
            .then(editConfigResponse => {
                setOpenAlert({
                    open: true
                })
            })
            .catch(err => {
                console.log(err);
                if (typeof err.response != "object") {
                }
                else {
                    if (err.response.status === 403) {
                        dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                    }
                }
            });

    }

    //Add Properties form
    const handleaddproperties = (rowData) => {
        setAddRowData(rowData);
        setOpenWizardForm(true);
        setUserComponent({
            ComponentName: rowData.component.name,
            ComponentPath: rowData.component.path
        })
        setOpenProperty({
            open: true,
            component: rowData.component.name
        })
        //Create
        if (rowData.component.name === "rock-entity-create") {
            try {
                if (rowData.component.hasOwnProperty("properties")) {
                    if (rowData.component.properties.hasOwnProperty("attributeNames")) {
                        setuserAttributes(rowData.component.properties.attributeNames)
                    }

                }
            } catch (error) { }
        }

        //Path-taxonomy Manage
        if (rowData.component.name === "rock-path-attribute-manage") {
            try {
                if (rowData.component.hasOwnProperty("properties")) {
                    setPathManageProperty({
                        ...rowData.component.properties
                    })
                }
            } catch (error) { }
        }

        //
        //Relationship Manage
        if (rowData.component.name === "rock-relationship-manage") {
            try {
                if (rowData.component.hasOwnProperty("properties")) {
                    setRelManageProperty({
                        ...rowData.component.properties
                    })
                }
            } catch (error) { }
        }

        // console.log("rowData",rowData);
    }

    ////Save Data
    const handleSaveClick = () => {
        let addjson = {}
        let margeproperty = null;

        //Create page step
        if (UserComponent.ComponentName === "rock-entity-create") {
            let addproperty = {
                "component": {
                    "properties": {
                        "attributeNames": userAttributes,
                        "noOfColumns": NoofColumns.NoofColumns
                    }
                }
            }
            margeproperty = merge(AddRowData, addproperty)



        }

        //Path attribute manage step
        if (UserComponent.ComponentName === "rock-path-attribute-manage") {
            let addproperty = {
                "component": {
                    "properties": PathManageProperty
                }
            }
            margeproperty = merge(AddRowData, addproperty)
        }

        //Relationship Manage Step
        if (UserComponent.ComponentName === "rock-relationship-manage") {
            let addproperty = {
                "component": {
                    "properties": RelManageProperty
                }
            }
            margeproperty = merge(AddRowData, addproperty)
        }

        //Update
        if (location.state && location.state.jsonDocument != "") {

            addjson = {
                "config":
                {
                    "steps": {
                        [margeproperty.name]: margeproperty
                    }
                }
            }

            let customconfig = location.state.jsonDocument.data.contexts[0].jsonData;
            let mergejson = merge(customconfig, addjson)
            location.state.jsonDocument.data.contexts[0].jsonData = mergejson;
            updateConfigAPI();

        }

        if (location.state === undefined) {

            jsonObj.jsonDocument.id = props.data.computedName;
            jsonObj.jsonDocument.name = props.data.computedName;
            jsonObj.jsonDocument.type = "UiConfig";
            jsonObj.jsonDocument.data.contexts[0].context.component = props.data.componentContextCode;
            jsonObj.jsonDocument.data.contexts[0].context.role = props.data.role;
            jsonObj.jsonDocument.data.contexts[0].context.tenant = props.data.tenant;
            jsonObj.jsonDocument.data.contexts[0].context.domain = props.data.domain;
            jsonObj.jsonDocument.data.contexts[0].context.entityType = props.data.entityType;
            jsonObj.jsonDocument.data.contexts[0].context.relationship = props.data.relationship;
            jsonObj.jsonDocument.data.contexts[0].context.app = props.data.app;
            jsonObj.jsonDocument.data.contexts[0].context.user = props.data.user;

            jsonObj._id = props.data._id;
            jsonObj.isPublished = false;
            jsonObj.componentContextCode = props.data.componentContextCode;
            jsonObj.domain = props.data.domain;
            jsonObj.entityType = props.data.entityType;
            jsonObj.context1 = props.data.context1;
            jsonObj.context2 = props.data.context2;
            jsonObj.context3 = props.data.context3;
            jsonObj.relationship = props.data.relationship;
            jsonObj.role = props.data.role;
            jsonObj.app = props.data.app;
            jsonObj.isDuplicate = props.data.isDuplicate;
            jsonObj.environmentId = props.data.environmentId;

            jsonObj.jsonDocument.data.contexts[0].jsonData = addjson;
            location.state = jsonObj
            updateConfigAPI("add");
            // history.push("./ManageConfig")

        }
    }

    //Steps Edit
    const handlewizarddata = (newData) => {

        let addjson = {
            "config":
            {
                "steps": {
                    [newData.name]: newData
                }
            }
        }
        if (location.state) {
            if (location.state.jsonDocument != '') {
                let customconfig = location.state.jsonDocument.data.contexts[0].jsonData;
                let mergejson = merge(customconfig, addjson)
                location.state.jsonDocument.data.contexts[0].jsonData = mergejson;
                updateConfigAPI();
                getSteps();
            }

            if (location.state.jsonDocument == '') {
                location.state.jsonDocument = jsonObj.jsonDocument
                location.state.jsonDocument.data.contexts[0].jsonData = addjson;
                updateConfigAPI();
                getSteps();
            }

        }
        if (location.state === undefined) {
            jsonObj.jsonDocument.id = props.data.computedName;
            jsonObj.jsonDocument.name = props.data.computedName;
            jsonObj.jsonDocument.type = "UiConfig";
            jsonObj.jsonDocument.data.contexts[0].context.component = props.data.componentContextCode;
            jsonObj.jsonDocument.data.contexts[0].context.role = props.data.role;
            jsonObj.jsonDocument.data.contexts[0].context.tenant = props.data.tenant;
            jsonObj.jsonDocument.data.contexts[0].context.domain = props.data.domain;
            jsonObj.jsonDocument.data.contexts[0].context.entityType = props.data.entityType;
            jsonObj.jsonDocument.data.contexts[0].context.relationship = props.data.relationship;
            jsonObj.jsonDocument.data.contexts[0].context.app = props.data.app;
            jsonObj.jsonDocument.data.contexts[0].context.user = props.data.user;

            jsonObj._id = props.data._id;
            jsonObj.isPublished = false;
            jsonObj.componentContextCode = props.data.componentContextCode;
            jsonObj.domain = props.data.domain;
            jsonObj.entityType = props.data.entityType;
            jsonObj.context1 = props.data.context1;
            jsonObj.context2 = props.data.context2;
            jsonObj.context3 = props.data.context3;
            jsonObj.relationship = props.data.relationship;
            jsonObj.role = props.data.role;
            jsonObj.app = props.data.app;
            jsonObj.isDuplicate = props.data.isDuplicate;
            jsonObj.environmentId = props.data.environmentId;

            jsonObj.jsonDocument.data.contexts[0].jsonData = addjson;
            location.state = jsonObj
            updateConfigAPI("add");
            getSteps();
        }
    }

    //Get Steps list
    const getSteps = () => {
        let baseconfig = null;
        let steps = null;
        let mapconfig = null;
        let url = "baseConfigurationGet"
        let postdata = {
            userId: reduxAuth.userId,
            token: reduxAuth.token,
            environmentId: appcomponent.selectedEnvironment.tenantId,
            componentContextCode: appcomponent.selectedComponent.componentContextCode
        }

        axios.post(url, postdata)
            .then(baseConfigResponse => {
                baseconfig = baseConfigResponse.data.response[0].jsonDocument.data.contexts[0].jsonData.config.steps;
                mapconfig = baseconfig;
                if (location.state) {
                    if (location.state.jsonDocument != '') {
                        let customconfig = location.state.jsonDocument.data.contexts[0].jsonData.config.steps;
                        mapconfig = merge(baseconfig, customconfig)
                    }

                }
                if (location.state === undefined) {
                    mapconfig = baseconfig
                }
                steps = Object.keys(mapconfig).map((keys) => {
                    mapconfig[keys].name = keys
                    return mapconfig[keys];
                })
                setSteps({
                    Steps: steps
                })
            })

    }

    //Get Context List
    const getContextList = () => {

        //Get ContextList
        let url = "getContextList"
        let postdata = {
            userId: reduxAuth.userId,
            token: reduxAuth.token,
            environmentId: appcomponent.selectedEnvironment.tenantId,
        }

        axios.post(url, postdata)
            .then(contextList => {
                let clist = contextList.data.response[0];
                setAttributelist({
                    AttributeList: clist.attribute
                })
                // setLoader(false)
            })
            .catch(err => {
                if (typeof err.response != "object") {
                    setErrorMessage({
                        open: true,
                        api: 'contextList',
                        errmsg: "Couldn't found context list please sync the tenant..."
                    })
                }
                else {
                    if (err.response.status === 403) {
                        dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                    }
                }
            });
    }

    useEffect(() => {

        getSteps();

        getContextList();

    }, []);


    return (
        <div>
            <div className={classes.root}>
                {openalert.open ?
                    <Snackbar
                        open={openalert.open} autoHideDuration={3000}
                        onClose={handleClose}>
                        <Alert
                            severity={"success"}
                            color={"info"}
                            variant="outlined">
                            Configuration Saved..
                        </Alert>
                    </Snackbar>
                    : null}
                <Snackbar
                    open={errorMessage.open} autoHideDuration={3000} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    onClose={handleClose}>
                    <Alert
                        severity="error"
                        color="error"
                        variant="filled">
                        {errorMessage.errmsg != null ? errorMessage.errmsg : " NetWork Error:Please Check Your Internet Connection"}
                    </Alert>
                </Snackbar>
                <div className={classes.stepperdiv}>
                    <div>
                        <div>
                            {OpenProperty.open ?
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="secondary"
                                    // disabled={activeStep === 0}
                                    onClick={() => handleSaveClick()}
                                    className={classes.backButton}
                                    style={{ fontSize: '0.700rem', fontWeight: 600 }}
                                    startIcon={<SaveIcon />}>
                                    Save
                                 </Button>
                                : null}

                            <Button variant="contained"
                                size="small"
                                style={{ fontSize: '0.700rem', fontWeight: 600 }}
                                color="primary"
                                onClick={() => handlebackbutton('Back To Search Result')}
                                startIcon={<SettingsBackupRestoreIcon />}>
                                Back To Search Result
                                </Button>
                        </div>
                    </div>
                </div>
            </div>
            <br />

            <div style={{ marginTop: '40px' }}>
                {!OpenWizardForm ?
                    <MaterialTable
                        title="Steps"
                        columns={StepsCol.columns}
                        data={Steps.Steps}
                        options={{
                            search: true,
                            sorting: true,
                            pageSize: 7,
                            pageSizeOptions: [7, 10, 50, 100],
                            padding: 'dense'
                        }}
                        editable={{
                            onRowAdd: (newData) =>
                                new Promise((resolve) => {
                                    setTimeout(() => {
                                        resolve();
                                        handlewizarddata(newData);
                                    }, 600);
                                }),
                            onRowUpdate: (newData) =>
                                new Promise((resolve) => {
                                    setTimeout(() => {
                                        resolve();
                                        handlewizarddata(newData);
                                    }, 600);
                                }),
                        }}
                    /> :

                    <Card className={classes.cardroot}>
                        <CardContent>

                            <br></br>

                            <TextField fullWidth disabled size="small" id="Component Name" label="Component Name" variant="outlined" value={UserComponent.ComponentName} />
                            <br></br><br></br>

                            {OpenProperty.open && OpenProperty.component === "rock-entity-create" ?
                                <>
                                    <br></br>
                                    <Autocomplete
                                        multiple
                                        id="Select Attribute"
                                        name="Attributes"
                                        size="small"
                                        options={AttributeList.AttributeList}
                                        onChange={handleAttributes}
                                        disableCloseOnSelect
                                        getOptionLabel={option => option}
                                        renderOption={(option, { selected }) => (
                                            <React.Fragment>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option}
                                            </React.Fragment>
                                        )}
                                        renderInput={params => (
                                            <TextField
                                                fullWidth
                                                {...params}
                                                variant="outlined"
                                                label="Attributes"
                                                size="small"
                                                placeholder="Add Attributes"
                                            />
                                        )}
                                        value={userAttributes}
                                    />
                                    <br></br><br></br>

                                    <TextField fullWidth
                                        id="outlined-basic"
                                        type="number"
                                        label="No of columns"
                                        variant="outlined"
                                        size="small"
                                        value={NoofColumns.NoofColumns}
                                        onChange={(event) => handleColumns(event)}
                                    />
                                </>
                                : null}

                            {OpenProperty.open && OpenProperty.component === "rock-path-attribute-manage" ?
                                <>
                                    <br></br>
                                    <Autocomplete
                                        id="Select Path Attribute"
                                        name="Select Path Attribute"
                                        size="small"
                                        options={AttributeList.AttributeList}
                                        onChange={handlepathattribute}
                                        getOptionLabel={option => option}
                                        renderInput={params => (
                                            <TextField
                                                fullWidth
                                                {...params}
                                                variant="outlined"
                                                label="Select Path Attribute"
                                                size="small"
                                                placeholder="Select Path Attribute"
                                            />
                                        )}
                                        value={PathManageProperty.pathAttribute}
                                    />
                                    <br></br><br></br>

                                    <FormControlLabel
                                        style={{ width: '45%', marginLeft: '5px', border: '1px solid', borderRadius: '5px' }}
                                        value="Leaf Node Only"
                                        control={<Switch id="Leaf Node Only" color="primary" checked={PathManageProperty.leafNodeOnly} />}
                                        label="Leaf Node Only"
                                        labelPlacement="end"
                                        onChange={handleleafnodeswitch}
                                    />

                                    <FormControlLabel
                                        style={{ width: '45%', marginLeft: "15px", border: '1px solid', borderRadius: '5px' }}
                                        value="Multi-Select"
                                        control={<Switch id="Multi-Select" color="primary" checked={PathManageProperty.multiSelect} />}
                                        label="Multi-Select"
                                        labelPlacement="end"
                                        onChange={handleleafnodeswitch}
                                    />
                                </>
                                : null}

                            {OpenProperty.open && OpenProperty.component === "rock-relationship-manage" ?
                                <>
                                    <TextField
                                        name="relationshipTitle"
                                        style={{ width: '45%' }}
                                        variant="outlined"
                                        label="Relationship Title"
                                        size="small"
                                        placeholder="Relationship Title"
                                        value={RelManageProperty["config-context"].relationshipTitle}
                                        onChange={(event) => handlerelpropertytextbox(event)} />

                                    <TextField
                                        name="relationshipTypeName"
                                        style={{ width: '45%', marginLeft: "5%" }}
                                        variant="outlined"
                                        label="Relationship Type Name"
                                        size="small"
                                        placeholder="Relationship Type Name"
                                        value={RelManageProperty["config-context"].relationshipTypeName}
                                        onChange={handlerelpropertytextbox} />

                                    <br></br><br></br>

                                    <TextField
                                        name="functional-mode"
                                        style={{ width: '45%' }}
                                        variant="outlined"
                                        label="functional-mode"
                                        size="small"
                                        placeholder="Functional Mode"
                                        value={RelManageProperty["functional-mode"]}
                                        onChange={handlerelpropertytextbox} />

                                    <TextField
                                        name="mode"
                                        style={{ width: '45%', marginLeft: "5%" }}
                                        variant="outlined"
                                        label="Mode"
                                        size="small"
                                        placeholder="Mode"
                                        value={RelManageProperty.mode}
                                        onChange={handlerelpropertytextbox} />

                                    <br></br><br></br>

                                    <TextField
                                        name="no-of-columns"
                                        style={{ width: '45%' }}
                                        type="number"
                                        variant="outlined"
                                        label="no-of-columns"
                                        size="small"
                                        placeholder="no-of-columns"
                                        value={RelManageProperty["no-of-columns"]}
                                        onChange={handlerelpropertytextbox} />

                                    <FormControlLabel
                                        style={{ width: '45%', marginLeft: "5%", border: '1px solid', borderRadius: '5px' }}
                                        value="do-sync-validation"
                                        control={<Switch id="do-sync-validation" color="primary" checked={RelManageProperty["do-sync-validation"]} />}
                                        label="do-sync-validation"
                                        labelPlacement="end"
                                        onChange={handlerelationmanageswitch}
                                    />

                                </>
                                : null}

                            {OpenProperty.open && OpenProperty.component === "rock-context-manage" || OpenProperty.open && OpenProperty.component === "rock-business-function-finish" ?
                                <>
                                    <center>Not Defined Property For {OpenProperty.component}</center>
                                </>
                                : null}

                        </CardContent>
                    </Card>

                }

            </div>
        </div>
    )
}


